import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/index.js'
import { defineCustomElements, addTheme } from 'corporate-ui'
import { theme as scania } from 'scania-theme'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas, faHeart } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { msalInstance } from './adAuth-config.js'
import { msalPlugin } from '@/plugins/msalPlugin.js'
import { EventType } from '@azure/msal-browser'
import { applyAzureAuthResult } from '@/components/ui/AzureADAuthentication.js'
import { getAuthProvider } from '@/oidc-config.js'
import 'vue3-datepicker/dist/vue3-datepicker.css'

library.add(fas, fab, faHeart)
addTheme(scania)
defineCustomElements()

async function bootstrap() {
  if (typeof msalInstance.initialize === 'function') {
    await msalInstance.initialize()
  }

  // Handle the MSAL redirect before the router or components inspect accounts.
  const redirectResult = await msalInstance.handleRedirectPromise()
  const accounts = msalInstance.getAllAccounts()
  const account =
    redirectResult?.account ??
    msalInstance.getActiveAccount() ??
    (accounts.length === 1 ? accounts[0] : null)

  if (account) {
    msalInstance.setActiveAccount(account)
  }

  // Restore OIDC state before route guards run after Azure redirects.
  try {
    await store.dispatch('oidc/getOidcUser')
   const expiresAt = store.getters['oidc/oidcAccessTokenExp']

  } catch (error) {
    console.error('Could not restore OIDC user:', error)
  }

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
      msalInstance.setActiveAccount(event.payload.account)
    }
  })

  if (redirectResult) {
    // Save the token and roles returned by Azure.
    const tokenCommitted = applyAzureAuthResult(redirectResult)
    if (!tokenCommitted) {
      console.error('Azure redirect completed without an account or access token.')
    }

    localStorage.setItem('adTokenUpdate', String(Date.now()))
    localStorage.setItem('sasTokenUpdate', String(Date.now()))
  }

  const app = createApp(App)
  app.component('FontAwesomeIcon', FontAwesomeIcon)
  app.config.warnHandler = () => null
  app.use(store)
  app.use(msalPlugin, msalInstance)
  app.use(router)
  await router.isReady()
  app.mount('#app')
}

bootstrap().catch((error) => {
  console.error('Application startup failed:', error)
})